import BaseHTMLColumnStrategy from './BaseHTMLColumnStrategy'

export default function BSHtmlBillableTasksStrategy() {}

BSHtmlBillableTasksStrategy.prototype = new BaseHTMLColumnStrategy();

BSHtmlBillableTasksStrategy.prototype.getLevelsNumber = function () {
    return 1;
};

BSHtmlBillableTasksStrategy.prototype.addFirstHeaderRowCells = function ( row, levelsNumber ) {
    this.addCell( row, this.message( "report.billing_summary.overall_spent.only_billible.html" ), "totalBillable", 1, levelsNumber );
};

BSHtmlBillableTasksStrategy.prototype.addSecondHeaderRowCells = function ( row, levelsNumber ) {
    // do nothing
};

BSHtmlBillableTasksStrategy.prototype.addColumnValueCells = function ( row ) {
    this.addTimeValueCell(row);
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/billingsummary/BSHtmlBillableTasksStrategy.js